export default "__VITE_ASSET__BPEHE9ag__"